"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const General_1 = require("../types/General");
const valueIsControlsLegacyControlEventDefinition = (0, ts_validators_1.buildValueIsShape)('LegacyControlEvent', {
    id: ts_validators_1.valueIsString,
    process: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        (0, ts_validators_1.buildValueIsArrayOf)(ts_validators_1.valueIsString),
    ]),
    type: ts_validators_1.valueIsString,
    [General_1.DEFINITION_PROP_NAMES.IS_NEW]: ts_validators_1.valueIsUndefined,
});
exports.default = valueIsControlsLegacyControlEventDefinition;
